export default "__VITE_ASSET__CT8gnINo__";